import styled from '@emotion/styled';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Theme } from '@mui/material';
import { FC } from 'react';
import { IconProps, ToastContainer, ToastContainerProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StyledConainer = styled('div')(({ theme }: { theme?: Theme }) => ({
  '.Toastify__toast-theme--colored.Toastify__toast--default': {
    backgroundColor: theme?.palette.primary.main,
    color: theme?.palette.primary.contrastText,
  },
  '.Toastify__toast-theme--colored.Toastify__toast--info': {
    backgroundColor: theme?.palette.info.main,
  },
  '.Toastify__toast-theme--colored.Toastify__toast--success': {
    backgroundColor: theme?.palette.success.main,
  },
  '.Toastify__toast-theme--colored.Toastify__toast--warning': {
    backgroundColor: theme?.palette.warning.main,
  },
  '.Toastify__toast-theme--colored.Toastify__toast--error': {
    backgroundColor: theme?.palette.error.main,
  },
  '.Toastify__close-button': {
    opacity: 1,
  },
  '.Toastify__toast-body > div::first-letter': {
    textTransform: 'capitalize' as const,
  },
}));

const ToasterIcon: FC<IconProps> = ({ type }) => {
  switch (type) {
    case 'error': {
      return <ErrorOutlineIcon />;
    }
    case 'success': {
      return <CheckCircleOutlineIcon />;
    }
    default: {
      return null;
    }
  }
};

export const MuiToastContainer: FC<ToastContainerProps> = props => {
  return (
    <StyledConainer>
      <ToastContainer icon={ToasterIcon} theme="colored" position="top-right" {...props} />
    </StyledConainer>
  );
};
